import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { PlainAccountDescription } from "./PlainAccountDescription";
import { ChangeAccountDescriptionComponent } from "./ChangeAccountDescription";
import { clientConfigFn } from "clientConfig";
class EditableAccountDescription extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isEditing: this.props.isEditing || false,
        };
        this.onStartEdit = () => {
            this.setState({ isEditing: true });
        };
        this.onFinishEdit = () => {
            this.setState({ isEditing: false });
        };
    }
    render() {
        const { isEditing } = this.state;
        const { description, accountId } = this.props;
        const { showAccountTitle } = clientConfigFn();
        if (!showAccountTitle) {
            return null;
        }
        if (!isEditing) {
            return (_jsx(PlainAccountDescription, { description: description, onStartEdit: this.onStartEdit }));
        }
        return (_jsx(ChangeAccountDescriptionComponent, { accountId: accountId, previousDescription: description, onCancel: this.onFinishEdit, onUpdated: this.onFinishEdit }));
    }
}
export { EditableAccountDescription };
